import { ReactNode, useContext, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { UserContext, UserContextType } from 'src/contexts/UserContext';
import { Layout } from 'src/components/layout';
import { isDesktop } from 'react-device-detect';
// import { useQueryClient } from 'react-query';
import { useRouterQuery } from 'src/hooks/use-router-query';
import { useModalRoute } from 'src/hooks/use-modal-route';
import { useSessionStorage } from 'src/hooks';
import { useRepplQuery } from 'src/app/reppl/hooks';
import { Metadata } from '../metadata';
import { SideWidget } from './side-widget';
import { canView } from './permission';
import { ArticleDetailModal } from '../article/detail-modal';
import { ArticleSource } from '../article/enum';
import RepplNotPublished from './reppl-not-published';

const RepplCoverV2 = dynamic(
  () =>
    isDesktop
      ? import('./reppl-cover/reppl-cover-v2')
      : import('./reppl-cover/reppl-cover-mobile-v2'),
  { ssr: true }
);

// const TAB_TITLE = {
//   collections: 'Collections',
//   episodes: 'Episodes',
//   about: 'About',
// };

export function RepplPageLayout(props) {
  const router = useRouter();
  const { rid, eid } = useRouterQuery('rid', 'eid');
  // const splitPathname = router.pathname.split('/');
  // const tabName: string =
  //   splitPathname.length === 4 ? TAB_TITLE[splitPathname[3]] : '';

  const articleModal = useModalRoute(!!eid);
  const reppl = props?.reppl?.reppl;

  return (
    <>
      {rid && (
        <>
          {reppl && (
            <Metadata
              image={reppl?.coverImgURL}
              title={reppl?.title}
              description={reppl?.summary}
              URL={`https://www.1tm.io${router.asPath}`}
            />
          )}
          <Layout header={props.header}>
            <RepplLayout rid={rid}>
              {props.children}
              <ArticleDetailModal
                source={ArticleSource.REPPL}
                modal={articleModal}
                publish
                id={eid}
              />
            </RepplLayout>
          </Layout>
        </>
      )}
    </>
  );
}

export function RepplLayout({
  rid,
  children,
}: {
  rid: string;
  children: ReactNode;
}) {
  // const queryClient = useQueryClient();
  const { user } = useContext(UserContext) as UserContextType;
  const {
    data: newRepplData,
    isLoading: newLoading,
    // isFetched,
    // isFetchedAfterMount,
  } = useRepplQuery(rid);
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();
  const reppl = newRepplData?.reppl;
  const creator = newRepplData?.creator;
  const [currRepplData, setCurrRepplData] = useState<any>();
  // const isMe = user && user.username === creator?.username;

  // const [hideCreateTip, setHideCreateTip] = useSessionStorage(
  //   'hide-create-tip',
  //   false
  // );

  useEffect(() => {
    if (newRepplData) {
      setCurrRepplData(newRepplData);
    } else {
      setCurrRepplData(reppl);
    }
  }, [newRepplData]);

  useEffect(() => {
    if (currRepplData && !newLoading) {
      setIsLoading(false);
    }
  }, [currRepplData, setCurrRepplData]);

  const invites = useSessionStorage('userInvitations', []);

  function getInvite(invite) {
    return invite.user === user.id && invite.rid === reppl?.id;
  }

  function isInvited() {
    const newInvites = invites[0];
    if (newInvites.find(getInvite)) {
      return true;
    }
    return false;
  }
  if (!isLoading && !canView(currRepplData)) {
    if (!isInvited()) {
      return <RepplNotPublished reppl={currRepplData} />;
    }
  }

  return (
    <>
      {/* <div>
        {!hideCreateTip && (
          <div className="text-gray-500 text-center py-3">
            <span className="mr-1 align-text-bottom">
              <SvgInfo fontSize="20px" className="inline" />
            </span>
            You can create posts from desktop or laptop.
            <span
              className="ml-4"
              onClick={() => setHideCreateTip(true)}
            >
              <SvgClearCircle fontSize="20px" className="inline" />
            </span>
          </div>
        )}
      </div> */}
      <RepplCoverV2 {...currRepplData} isLoading={isLoading} isFetched />
      {/* <RepplCover
        {...repplData}
        loading={isLoading || !reppl || router.isFallback}
        isFetchedAfterMount={isFetchedAfterMount}
      /> */}
      <div className="mt-3 pb-0 md:mt-8 reppl-container mx-auto md:flex md:pb-20">
        <div className="px-3 md:px-0 md:flex-1 w-full md:w-auto">
          {children}
        </div>
        {router.pathname !== '/reppl/[rid]' &&
          router.pathname !== '/reppl/[rid]/about' &&
          router.pathname !== '/reppl/[rid]/episode/[eid]' && (
            <div className={`${!isDesktop && 'hidden'} side-widget ml-6`}>
              <SideWidget
                reppl={reppl}
                loading={isLoading || !creator}
                creator={creator}
              />
            </div>
          )}
        {router.pathname === '/reppl/[rid]/about' && (
          <div className="side-widget ml-6">
            <SideWidget
              reppl={reppl}
              loading={isLoading || !creator}
              creator={creator}
            />
          </div>
        )}
      </div>
    </>
  );
}
